export const DIGIT = /^[0-9]$/;
export const DAY_SYMBOL = {
    value: 'd',
    match: DIGIT.test.bind(DIGIT),
    placeholderCharacter: 'd',
};

export const MONTH_SYMBOL = {
    value: 'M',
    match: DIGIT.test.bind(DIGIT),
    placeholderCharacter: 'M',
};

export const YEAR_SYMBOL = {
    value: 'y',
    match: DIGIT.test.bind(DIGIT),
    placeholderCharacter: 'y',
};

export const dateMatchableSymbols = [DAY_SYMBOL, MONTH_SYMBOL, YEAR_SYMBOL];
